// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3I0VL","tab":"ProcedureTabs_tab__2HaAY"};